// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api.js";
import ResponseChecker from "../Middlewares/ResponseChecker.js";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints/index.js";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

/*
 request.map of Refrigerants
  GetAll,
  Create,
  GetById,
  Update,
  Delete
*/

// ## Refrigerants Get
/**
 *
 * @param {{params: object, query: { page: number, limit: number, search: string }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.Refrigerants.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};
// ## Refrigerants Create
/**
 *
 * @param {{ "key": "string", value: "string" }} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.Refrigerants.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Refrigerants Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.Refrigerants.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Refrigerants Update
/**
 *
 * @param {{ "key": "string", value: "string" }} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(Endpoints.Refrigerants.Update(option), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Refrigerants Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.Refrigerants.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Refrigerants Get By Series
/**
 *
 * @param {{params: { id: string }, query: object}} option
 *
 * @returns
 */
export const GetRefrigerantBySeries = async (option) => {
  const response = await $api.get(
    Endpoints.Refrigerants.GetRefrigerantBySeries(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
  GetRefrigerantBySeries,
};
